import { ExternalLink } from "lucide-react";
import { socialLinks } from "@/data/content";

export const SocialSection = () => (
    <div className="fade-in" data-testid="social-section">
      <h2 className="text-4xl sm:text-5xl font-bold mb-12 text-center" data-testid="social-title">
        Suivez-nous sur les réseaux
      </h2>
      
      <div className="grid sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
        {socialLinks.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all hover:scale-105"
            data-testid={`social-link-${social.name.toLowerCase().replace(/\s/g, '-')}`}
          >
            <div className="flex flex-col items-center">
              <social.icon size={48} className={`mb-3 transition-colors ${social.color}`} />
              <h3 className="text-2xl font-bold">{social.name}</h3>
            </div>
          </a>
        ))}
      </div>

      {/* Contact Section */}
      <div className="mt-16 max-w-2xl mx-auto">
        <h3 className="text-3xl font-bold mb-8 text-center" data-testid="contact-title">Contacts Telegram</h3>
        <div className="space-y-4">
          <a
            href="https://t.me/DeoFavente700s"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all"
            data-testid="contact-link-1"
          >
            <span className="font-medium">@DeoFavente700s</span>
            <ExternalLink size={20} />
          </a>
          <a
            href="https://t.me/favente"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between p-6 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all"
            data-testid="contact-link-2"
          >
            <span className="font-medium">@favente</span>
            <ExternalLink size={20} />
          </a>
        </div>
      </div>
    </div>
);
